import React from 'react';
import {
  CallToActionButton, FDBox, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  EstatePlanningC2BWrapper,
} from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/components/EstatePlanningC2BWrapper';
import { dispatchWizardFinishedRefresh } from 'Hooks/useRefreshEvent';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const EstatePlanningInitializeIntroStepLayout = () => {
  const {
    onSubmit,
    saving,
    resource,
  } = useMetaLayoutContext();
  const {
    clearModalCollection,
  } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleNext = async () => {
    try {
      await onSubmit();
    } catch (err) {
      displayErrorMessage(err, err.errors || 'Failed to initialize estate plan. Please try again later');
    }
  };

  return (
    <EstatePlanningC2BWrapper>
      <MetaControlField
        attr={'subtitle'}
        hideEmptyFields
      />
      <FDBox paddingY={2}>
        <FDStack direction={'row'} alignItems={'flex-start'} spacing={2}>
          <CallToActionButton
            onClick={async () => handleNext()}
            label={resource?.attr('primaryActionLabel') || 'Continue'}
            loading={saving}
          />
          <FDSecondaryActionButton
            onClick={async () => {
              clearModalCollection();
              dispatchWizardFinishedRefresh();
            }}
            label={'Cancel'}
          />
        </FDStack>
      </FDBox>
    </EstatePlanningC2BWrapper>
  );
};

EstatePlanningInitializeIntroStepLayout.defaultProps = {
};

EstatePlanningInitializeIntroStepLayout.propTypes = {
};

export { EstatePlanningInitializeIntroStepLayout };
